import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

export const MediumIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      fill="#000000"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="48px"
      height="48px">
      <path d="M14.5 12.129999999999999A12.5 12.5 0 1014.5 37.129999999999995 12.5 12.5 0 1014.5 12.129999999999999zM39.73 21.211c-.058-.36-.126-.713-.202-1.057-.152-.688-.338-1.342-.553-1.953-.108-.306-.223-.601-.345-.885-.489-1.136-1.09-2.089-1.77-2.797-.85-.885-1.824-1.388-2.86-1.388s-2.01.503-2.86 1.388c-.68.708-1.281 1.661-1.77 2.797-.122.284-.238.579-.345.885-.216.612-.401 1.266-.553 1.953-.076.344-.143.696-.202 1.057C28.094 22.291 28 23.44 28 24.63c0 6.351 2.686 11.5 6 11.5s6-5.149 6-11.5C40 23.44 39.906 22.291 39.73 21.211zM43.5 14.13c-1.381 0-2.5 4.701-2.5 10.5 0 .362.004.721.013 1.074.051 2.118.252 4.05.558 5.605.102.519.215.995.339 1.423.123.428.257.807.399 1.13.354.808.76 1.267 1.192 1.267s.837-.459 1.192-1.267c.142-.323.275-.702.399-1.13.123-.428.237-.905.339-1.423.306-1.556.507-3.487.558-5.605C45.996 25.351 46 24.993 46 24.63 46 18.831 44.881 14.13 43.5 14.13z" />
    </SvgIcon>
  );
};
